import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { EnhancedAutocomplete, FullRow, IconButton } from 'seagull';
import { Edit } from 'seagull/icons/content-edit';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { SAMPLE_CLIENT_ID } from '../ClientRecipients.utils';
import styles from './ClientPicker.module.scss';
import { findClientOption, isRealClientSelected, isSampleSelected, toClientOptions } from './ClientPicker.utils';
export const GetClientPickerTID = (parentTestId)=>getTestIds(parentTestId);
export const ClientPicker = (param)=>{
    let { clients, isLoading, error, onRetry, selectedClientId, onSelectClient, onSelectSample, onCreateClient, onEditClient, disabled, testId } = param;
    const { t: clientPickerTexts } = useLocaleKeys('components.clientPicker');
    const { ClientPickerTestIds } = useMemo(()=>GetClientPickerTID(testId), [
        testId
    ]);
    const options = useMemo(()=>toClientOptions(clients), [
        clients
    ]);
    const showRealClient = isRealClientSelected(selectedClientId);
    const showSample = isSampleSelected(selectedClientId);
    const selectedOption = showSample ? {
        clientId: SAMPLE_CLIENT_ID,
        name: clientPickerTexts.sampleClient()
    } : findClientOption(options, selectedClientId);
    const hasError = error != null;
    return /*#__PURE__*/ _jsxs(FullRow, {
        gap: 8,
        alignItems: "center",
        testId: ClientPickerTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx(EnhancedAutocomplete, {
                bi: {
                    name: 'client_picker'
                },
                testId: ClientPickerTestIds.Autocomplete(),
                className: styles.field,
                size: "medium",
                disabled: disabled,
                options: options,
                keyField: "clientId",
                labelField: "name",
                isLoading: isLoading,
                textFieldProps: {
                    bi: {
                        name: 'client_picker'
                    },
                    label: clientPickerTexts.clientLabel(),
                    placeholder: clientPickerTexts.placeholder(),
                    alwaysShrinkLabel: true
                },
                selectedOption: selectedOption,
                applyOptionChange: (option)=>{
                    if (option == null) {
                        return;
                    }
                    onSelectClient(option.clientId);
                },
                newItemOption: [
                    {
                        text: clientPickerTexts.createNew(),
                        onClick: async ()=>onCreateClient()
                    }
                ],
                promotionalActionOption: {
                    title: clientPickerTexts.sampleClientActionTitle(),
                    body: clientPickerTexts.sampleClientActionBody(),
                    onClick: onSelectSample
                },
                emptySearchText: clientPickerTexts.clientNoMatch(),
                error: hasError,
                helperText: hasError ? clientPickerTexts.failedToLoadClients() : undefined,
                onRefresh: onRetry ? async ()=>onRetry() : undefined
            }),
            showRealClient && /*#__PURE__*/ _jsx(IconButton, {
                bi: {
                    name: 'edit_client_pencil'
                },
                testId: ClientPickerTestIds.EditPencil(),
                disabled: disabled,
                onClick: ()=>selectedClientId != null && onEditClient(selectedClientId),
                children: /*#__PURE__*/ _jsx(Edit, {})
            })
        ]
    });
};
